import e from "../_virtual/_plugin-vue_export-helper.js";
import { Fragment as t, createElementBlock as n, createElementVNode as r, openBlock as i } from "vue";
//#region src/icons-legacy/fulfilment-24.vue
var a = {};
function o(e, a) {
	return i(), n(t, null, [
		a[0] ||= r("path", {
			"clip-rule": "evenodd",
			d: "M12.6286 1.23962C12.2297 1.05554 11.7703 1.05554 11.3714 1.23962L5.87141 3.77808C5.34019 4.02327 5 4.55495 5 5.14002V12.8604C5 13.4454 5.34019 13.9771 5.87141 14.2223L11.3714 16.7608C11.7703 16.9448 12.2297 16.9448 12.6286 16.7608L18.1286 14.2223C18.6598 13.9771 19 13.4454 19 12.8604V5.14002C19 4.55495 18.6598 4.02327 18.1286 3.77808L12.6286 1.23962ZM11.7905 2.14758C11.9234 2.08622 12.0766 2.08622 12.2095 2.14758L17.3069 4.50022L15.3493 5.40371C15.2802 5.35621 15.2064 5.31413 15.1286 5.2782L10.068 2.94256L11.7905 2.14758ZM8.87488 3.49324L6.6931 4.50022L11.7905 6.85285C11.9234 6.91421 12.0766 6.91421 12.2095 6.85285L14.1818 5.94258L8.87488 3.49324ZM15 6.66631L12.6286 7.76081C12.5864 7.7803 12.5434 7.79773 12.5 7.81309V15.7187L17.7095 13.3143C17.8866 13.2326 18 13.0554 18 12.8604V5.2817L15.9432 6.231C15.9804 6.36214 16 6.4996 16 6.64014V8.5003C16 8.77645 15.7761 9.0003 15.5 9.0003C15.2239 9.0003 15 8.77645 15 8.5003V6.66631ZM6 5.2817V12.8604C6 13.0554 6.1134 13.2326 6.29047 13.3143L11.5 15.7187V7.81309C11.4566 7.79773 11.4136 7.7803 11.3714 7.76081L6 5.2817Z",
			fill: "#FF8C00",
			"fill-rule": "evenodd"
		}, null, -1),
		a[1] ||= r("path", {
			d: "M0.5 8C0.223858 8 0 8.22386 0 8.5C0 8.77614 0.223858 9 0.5 9V8ZM4.5 9H5V8H4.5V9ZM0.5 9H4.5V8H0.5V9Z",
			fill: "#FF8C00"
		}, null, -1),
		a[2] ||= r("path", {
			d: "M19.5 8H19V9H19.5V8ZM22.5 9C22.7761 9 23 8.77614 23 8.5C23 8.22386 22.7761 8 22.5 8V9ZM19.5 9H22.5V8H19.5V9Z",
			fill: "#FF8C00"
		}, null, -1),
		a[3] ||= r("path", {
			d: "M0.5 18.5H22.5",
			fill: "none",
			stroke: "#FF8C00",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		a[4] ||= r("path", {
			d: "M2.5 21.5C2.5 22.0523 2.05228 22.5 1.5 22.5C0.947715 22.5 0.5 22.0523 0.5 21.5C0.5 20.9477 0.947715 20.5 1.5 20.5C2.05228 20.5 2.5 20.9477 2.5 21.5Z",
			fill: "none",
			stroke: "#FF8C00",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		a[5] ||= r("path", {
			d: "M6.5 21.5C6.5 22.0523 6.05228 22.5 5.5 22.5C4.94772 22.5 4.5 22.0523 4.5 21.5C4.5 20.9477 4.94772 20.5 5.5 20.5C6.05228 20.5 6.5 20.9477 6.5 21.5Z",
			fill: "none",
			stroke: "#FF8C00",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		a[6] ||= r("path", {
			d: "M10.5 21.5C10.5 22.0523 10.0523 22.5 9.5 22.5C8.94772 22.5 8.5 22.0523 8.5 21.5C8.5 20.9477 8.94772 20.5 9.5 20.5C10.0523 20.5 10.5 20.9477 10.5 21.5Z",
			fill: "none",
			stroke: "#FF8C00",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		a[7] ||= r("path", {
			d: "M14.5 21.5C14.5 22.0523 14.0523 22.5 13.5 22.5C12.9477 22.5 12.5 22.0523 12.5 21.5C12.5 20.9477 12.9477 20.5 13.5 20.5C14.0523 20.5 14.5 20.9477 14.5 21.5Z",
			fill: "none",
			stroke: "#FF8C00",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		a[8] ||= r("path", {
			d: "M18.5 21.5C18.5 22.0523 18.0523 22.5 17.5 22.5C16.9477 22.5 16.5 22.0523 16.5 21.5C16.5 20.9477 16.9477 20.5 17.5 20.5C18.0523 20.5 18.5 20.9477 18.5 21.5Z",
			fill: "none",
			stroke: "#FF8C00",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		a[9] ||= r("path", {
			d: "M22.5 21.5C22.5 22.0523 22.0523 22.5 21.5 22.5C20.9477 22.5 20.5 22.0523 20.5 21.5C20.5 20.9477 20.9477 20.5 21.5 20.5C22.0523 20.5 22.5 20.9477 22.5 21.5Z",
			fill: "none",
			stroke: "#FF8C00",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1)
	], 64);
}
var s = /*#__PURE__*/ e(a, [["render", o]]);
//#endregion
export { s as default };
